<template>
  <MainAuthLayout>
    <template v-slot:form>
      <router-view />
    </template>
  </MainAuthLayout>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import MainAuthLayout from '@/layouts/MainAuthLayout'

export default {
  components: {
    MainAuthLayout
  },

  computed: {
    ...mapState({
      isAuthenticated: state => state.auth.isAuthenticated,
      user: state => state.auth.user
    })
  },

  methods: {
    ...mapActions({
      getAuthenticatedUser: 'auth/getAuthenticatedUser'
    }),

    async created() {
      const authRoutes = [
        'auth.login-page',
        'auth.forgot-password-page',
        'auth.register-page'
      ]
      if (this.isAuthenticated) {
        if (!this.user) {
          await this.getAuthenticatedUser()
        }
        if (
          !this.user.first_name &&
          !this.user.last_name &&
          !this.user.business_contact_number
        ) {
          this.$router.replace({ name: 'auth.onboarding-page' }).catch(() => {})
        } else {
          this.$router.replace({ name: 'user.profile-page' })
        }
      } else if (!authRoutes.includes(this.$route.name)) {
        this.$router.replace({ name: 'auth.login-page' }).catch(() => {})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.template-container {
  width: 500px;
}
@media (max-width: 576px) {
  .template-container {
    width: 100%;
  }
}
</style>
